import ReportIntro from '@app/components/reports/components/report-intro';
import { useGetReportTags } from '@app/components/reports/utils';
import { OperationReportTypeEnum } from '@shared/api/types';
import { useSalesReportResult } from '../sales-report-result-context';

export default function SalesReportIntro() {
  const { result, downloadMode } = useSalesReportResult();
  const tags = useGetReportTags(result);

  return (
    <ReportIntro
      reportType={OperationReportTypeEnum.sales}
      result={result}
      downloadMode={downloadMode}
      tags={tags}
    />
  );
}
